const getYandexGeoData = async (geocode: string) => {
  const url =
    "https://geocode-maps.yandex.ru/v1/?apikey=773f6a0d-8eb8-444c-b4f9-8b27031c75ff&format=json&result=1&";
  const fullUrl = url + `geocode=${geocode}`;
  try {
    const response = await fetch(fullUrl, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    if (!data.response.GeoObjectCollection.featureMember) {
      console.error("Ошибка при получении координат:");
      return null;
    }
    return data.response.GeoObjectCollection.featureMember;
  } catch (error) {
    console.error("Ошибка при получении координат:", error);
    return null;
  }
};

export default getYandexGeoData;
